"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _slice = require("@lce/slice");

var _SuperLink = _interopRequireDefault(require("../../../SuperLink"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Link = (0, _styledComponents["default"])(_SuperLink["default"])(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  font-size: 20px;\n  font-weight: 500;\n  text-align: left;\n  text-decoration: none;\n  transition: background-color 0.3s ease;\n  marginBottom: 0;\n  padding: 12px 16px;\n  border-radius: 3px;\n  background-color: ", ";\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n\n  ", " {\n    font-size: 18px;\n    padding: 8px 16px;\n    marginBottom: 4px;\n    background-color: initial;\n\n    &:hover {\n      background-color: ", ";\n      text-decoration: none;\n    }\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"], ["\n  font-size: 20px;\n  font-weight: 500;\n  text-align: left;\n  text-decoration: none;\n  transition: background-color 0.3s ease;\n  marginBottom: 0;\n  padding: 12px 16px;\n  border-radius: 3px;\n  background-color: ", ";\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n\n  ", " {\n    font-size: 18px;\n    padding: 8px 16px;\n    marginBottom: 4px;\n    background-color: initial;\n\n    &:hover {\n      background-color: ", ";\n      text-decoration: none;\n    }\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"])), function (_a) {
  var theme = _a.theme,
      isactive = _a.isactive;
  return "" + (isactive ? theme.colors['pale-grey'] : 'inherit');
}, function (_a) {
  var theme = _a.theme;
  return "" + theme.colors['pale-grey'];
}, _slice.mediaQueries[0], function (_a) {
  var theme = _a.theme;
  return "" + theme.colors['pale-grey'];
});
exports.Link = Link;
var templateObject_1;